import { Component } from '@angular/core';
import { CoreSignalMemberOrganizationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Member Organizations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalmemberorganization-form',
    templateUrl: './coresignalmemberorganization.form.component.html'
})
export class CoreSignalMemberOrganizationFormComponent extends BaseFormComponent {
    public record!: CoreSignalMemberOrganizationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

